'use client'

import { useTranslations } from 'next-intl'
import React, { useMemo } from 'react'

import { ZEditorJsRenderer } from '@/_components/universal/editorjs-renderer'
import { IAmbulance, IPriceListGroup, PRICE_LIST_ITEM_TYPE_ENUM } from '@/_types'
import ZAmbulanceContentSidebar from '@/app/[locale]/ambulance/components/content/z-ambulance-content-sidebar'

import AAmbulancePriceList from '../../../components/price-list/a-ambulance-price-list'
import AAmbulanceServices from '../../../components/services/a-ambulance-services'

interface IProps {
	ambulance: IAmbulance
	priceGroup: IPriceListGroup
}

export default function APriceGroupContent({ ambulance, priceGroup }: IProps) {
	const t = useTranslations('pages.ambulance_offered_services')

	const sidebarItems = [
		...(!!priceGroup.text && priceGroup.text?.blocks?.length
			? [{ href: '#o-sluzbe', label: t('sidebar.aboutService') }]
			: []),
		...(!!priceGroup.items.length ? [{ href: '#cennik', label: t('sidebar.priceList') }] : [])
	]

	const packagePriceListItems = useMemo(() => {
		return priceGroup.items.filter(item => item.type === PRICE_LIST_ITEM_TYPE_ENUM.PACKAGE)
	}, [priceGroup.items])

	const servicePriceListItems = useMemo(() => {
		return priceGroup.items.filter(item => item.type === PRICE_LIST_ITEM_TYPE_ENUM.SERVICE)
	}, [priceGroup.items])

	return (
		<div className='box_amb'>
			<ZAmbulanceContentSidebar sidebarItems={sidebarItems} />

			{!!(priceGroup.text && priceGroup.text?.blocks?.length) && (
				<section id='o-sluzbe' className='pdt-70lg pdt-100'>
					<div className='wrapper_full'>
						<div className='wrapper_amb'>
							<div className='section_head mgt-80lg mgt-90 mgl-0lg mgl-120'>
								<div className='anim_delay anim_drop1 observe'>
									<ZEditorJsRenderer data={priceGroup.text} className='!pb-0' />
								</div>
							</div>
						</div>
					</div>
				</section>
			)}

			<AAmbulanceServices
				ambulance={ambulance}
				priceListItems={packagePriceListItems}
				allPriceListItems={priceGroup.items}
			/>
			<AAmbulancePriceList
				ambulance={ambulance}
				priceListItems={servicePriceListItems}
				allPriceListItems={priceGroup.items}
			/>
		</div>
	)
}
